import Vue from 'vue';
import i18n from "../../../i18n";

export default {

  async createTranslation({ dispatch, commit }, payload) {
    return Vue.axios.post(Vue.$url("translation/" + payload.key + '/' + payload.lang), payload)
      .then((rsp) => {
        Vue.$log.debug("translation created and saved under", rsp.data.key);
        dispatch('fetchTranslations');
        commit('mShowInfoMessage', i18n.t('common.saved', { 0: 'Translation', 1: payload.value }), { root: true });
      })
  },

  async fetchTranslations({ commit }) {
    Vue.$log.debug('fetching translations');

    return Vue.axios.get(Vue.$url('translation'))
      .then((rsp) => commit("SET_TRANSLATIONS", rsp.data))
  },

  async updateTranslation({ dispatch, commit }, payload) {
    return Vue.axios
      .put(Vue.$url("translation/" + payload.key + '/' + payload.lang), payload)
      .then((rsp) => {
        dispatch('fetchTranslations');
        commit('mShowInfoMessage', i18n.t('common.updated', { 0: 'Translation', 1: payload.value }), { root: true });
        return rsp.data;
      })

  },
  async deleteTranslation({ dispatch, commit }, payload) {
    Vue.$log.debug('trying to delete translation', payload.key);
    return Vue.axios
      .delete(Vue.$url("translation/" + payload.key + '/' + payload.lang))
      .then(() => {
        dispatch('fetchTranslations');
        commit('mShowInfoMessage', i18n.t('common.deleted', { 0: payload.value }), { root: true });
      })

  },
}